export const SET_SERVICESLIST = "SERVICESLIST/SET_SERVICESLIST";
